<template>
  <div>
    <div class="title">
      <h1>{{payInfo.phoneNum}}-{{payInfo.person}}先生/女士，</h1>
      <h1>购买{{payInfo.ticketType}}，{{payInfo.ticketNum}}张,</h1>
      <h1>总计{{money}}元(RMB)</h1>      
      <button type="button" @click='wxpay'>确认并支付</button>      
    </div>  
  </div>  
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      id: "",
      payInfo: {
        acid: "1",
        company: "",
        person: "",
        position: "",
        phoneNum: "",
        email: "",
        card: "",
        ticketType: "",
        ticketTypePinyin: "",
        ticketNum: 0
      }
    };
  },
  created() {
    this.id = this.$route.params.personid;
    let id = this.$route.params.personid;
    axios({
      method: "post",
      url: "/acapi/ac/estateforum_ticket/get_person",
      data: { id }
    }).then(res => {
      if (res.data.statusCode === 200) {
        this.payInfo = {...res.data.result}
      }
    });
  },
  methods: {},
  computed: {}
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/frontend/estateforum/pay.vue